export interface TransifyOptions {
  i18n: {
    t: Function
  }
  tUpper: Function
}

/**
 * 覆盖 transifyOptions 配置
 */
export const transifyOptions: TransifyOptions = {
  i18n: {
    t: (val: string) => {
      return val
    }
  },
  tUpper: (val: string) => val
}
export const registerTransifyOptions = (_transifyOptions: TransifyOptions) => {
  transifyOptions.i18n = _transifyOptions.i18n
  transifyOptions.tUpper = _transifyOptions.tUpper
}
